import { render, staticRenderFns } from "./actionMenu.vue?vue&type=template&id=5b4690b8"
import script from "./actionMenu.vue?vue&type=script&lang=js"
export * from "./actionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports